import { render } from "./VenueSearch.vue?vue&type=template&id=3cb19b6a"
import script from "./VenueSearch.vue?vue&type=script&lang=js"
export * from "./VenueSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__